/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

export interface Collaborator {
  readonly therapistId: string;
  readonly fullName: string;
  readonly addedAt: string;
}

export const collaboratorsApi = {
  async list(planId: string): Promise<readonly Collaborator[]> {
    const { data } = await apiClient.get<readonly Collaborator[]>(`/itps/${planId}/collaborators`);
    return data;
  },
  async add(planId: string, therapistId: string): Promise<readonly Collaborator[]> {
    const { data } = await apiClient.post<readonly Collaborator[]>(
      `/itps/${planId}/collaborators`,
      {
        therapistId,
      },
    );
    return data;
  },
  async remove(planId: string, therapistId: string): Promise<readonly Collaborator[]> {
    const { data } = await apiClient.delete<readonly Collaborator[]>(
      `/itps/${planId}/collaborators/${therapistId}`,
    );
    return data;
  },
};
